// KARTA KODI — TAQDIM ETUVCHIGA XIZMAT QILUVCHI SIR.
//
// =====================================================================
// ⛔ NEGA KOD BERKITILADI — bu bezak emas, pul masalasi
// =====================================================================
// Kartaning kodi bearer-token: uni KO'RGAN odam kartani o'zi ishlatib
// yuboradi va buning uchun qog'oz karta ham, xarid ham kerak emas
// (`POST /api/vouchers/activate` faqat kod va login so'raydi). Ya'ni
// yonidan o'tib ketayotgan odam ekranga qarasa — sotilmagan karta
// yo'qoladi, sherik esa buni faqat mijoz shikoyat qilganda biladi.
//
// ⛔ SHUNING UCHUN BERKITISH HOLATGA BOG'LIQ, «hammasi berkitilsin»
// EMAS: ishlatilgan, kuygan va bekor qilingan kartaning kodi endi
// hech kimga foyda bermaydi, sherikka esa u AYNAN nizoni hal qilish
// uchun kerak («shu kod ishlamayapti» degan mijoz bilan). Hammasini
// berkitish o'sha yagona foydali holatni yopardi va hech nimani
// qo'shimcha himoya qilmasdi.

// ⚠️ FAQAT `import type` — bu fayl SOF MANTIQ bo'lib qolishi kerak.
// `tests/guards.mjs` uni o'girib, funksiyalarni BEVOSITA chaqiradi;
// haqiqiy import bo'lsa u butun ilova daraxtini (axios, zod, antd)
// tortib kelardi va qorovul umuman yurmasdi (`commissionRule.ts` dagi
// ayni qaror va ayni izoh).
import type { VoucherState } from './voucherStockApi'

/**
 * Kodi SIR bo'lgan holatlar.
 *
 * ⚠️ Bu ro'yxat «qaysi kartani hali ishlatish mumkin» degan savolga ham
 * javob beradi va IKKALASI BIR XIL sabab bilan: `NEW` va `SOLD` kartani
 * ko'rgan odam uni O'ZI ishlatib yuboradi
 * (`VoucherState.isActivatable()` — aynan shu ikkitasi). Qolgan uchtasi
 * endi hech kimga foyda bermaydi, ya'ni ularni yashirish SOF ZARAR:
 * sherik nizoni hal qilish uchun aynan ishlatilgan kodni izlaydi.
 */
export const SECRET_STATES: ReadonlySet<VoucherState> = new Set<VoucherState>(['NEW', 'SOLD'])

/**
 * Niqob belgisi.
 *
 * ⚠️ YULDUZCHA (`*`) EMAS va bu o'lchangan farq: `contactDraft.ts` dagi
 * `isMaskedValue` aynan yulduzcha bo'yicha «bu niqoblangan qiymat» deb
 * qaror qiladi. Bir xil belgi ishlatilsa, kod bilan telefon bir kun
 * bir-birining tekshiruviga tushib qolardi.
 */
const MASK_CHAR = '•'

/**
 * Kartaning holatida kodi SIRMI.
 *
 * ⚠️ Manba `SECRET_STATES` — `VoucherState.isActivatable()` ning aynan
 * o'zi (`NEW`, `SOLD`). «Ishlatish mumkin» va «sir» BIR XIL savol:
 * kodni ko'rgan odam faqat ishlatilishi mumkin bo'lgan kartani o'g'irlay
 * oladi.
 */
export function isCodeSecret(state: VoucherState): boolean {
  return SECRET_STATES.has(state)
}

/**
 * Kodning berkitilgan ko'rinishi — `AF10G` + nuqtalar.
 *
 * <h2>⚠️ NEGA AYNAN PARTIYA PREFIKSI QOLADI</h2>
 * Prefiks partiyaning HAMMA kartasida bir xil (`VoucherCodeGenerator`),
 * ya'ni u kartani AJRATMAYDI va shuning uchun uni ko'rsatish hech narsa
 * oshkor qilmaydi. Tasodifiy qismdan bir necha belgi qoldirish esa
 * ENTROPIYANI kamaytirardi — va aynan o'sha qism sir.
 *
 * ⚠️ UZUNLIK SAQLANADI: nuqtalar soni haqiqiy kodning qolgan qismi
 * bilan teng. Bu operatorga «kod qanchalik uzun» degan zararsiz
 * ma'lumotni beradi va qatorlar bir xil kenglikda turadi.
 *
 * ⚠️ Prefiks NOMA'LUM yoki kodga mos kelmasa — HAMMASI berkitiladi.
 * «Bo'lmasa boshidan uchtasini qoldiraylik» degan zaxira yo'l aynan
 * yuqorida rad etilgan narsani orqa eshikdan kiritardi.
 */
export function maskCode(code: string, prefix: string | null): string {
  const clean = code.trim()
  if (clean === '') return ''

  const head = prefix?.trim() ?? ''
  if (head !== '' && clean.startsWith(head) && clean.length > head.length) {
    return `${head}-${MASK_CHAR.repeat(clean.length - head.length)}`
  }
  return MASK_CHAR.repeat(clean.length)
}

/**
 * Ekranda ko'rinadigan kod.
 *
 * @param revealed operator «ko'rsatish» ni bosganmi — FAQAT sir
 *                 holatdagi kartaga ta'sir qiladi
 *
 * ⚠️ Tartib muhim: avval holat, keyin operator tanlovi. Teskarisida
 * («ochilgan bo'lsa ko'rsat») sir bo'lmagan kartaning kodi ham
 * tugmaga bog'lanib qolardi va sherik uni har safar bosishga majbur
 * bo'lardi — hech qanday himoya bermasdan.
 */
export function displayCode(
  code: string,
  state: VoucherState,
  prefix: string | null,
  revealed: boolean,
): string {
  if (!isCodeSecret(state)) return code
  return revealed ? code : maskCode(code, prefix)
}

/**
 * CHOP ETISHGA ketadigan kod — HAR DOIM TO'LIQ.
 *
 * ⛔ Bu funksiya ataylab {@link displayCode} dan AYRI turadi va niqobni
 * UMUMAN bilmaydi. Egasining talabi aniq: «chop etilgan kartada kod
 * albatta to'liq chiqadi». Ikkalasi bitta funksiyada bo'lsa, ekrandagi
 * niqob bir kun qog'ozga ham tushardi — va buni faqat mijoz
 * yulduzchali kartani olib kelganda bilib qolardik.
 */
export function printableCode(code: string): string {
  return code
}

/**
 * QOG'OZGA CHIQADIGAN holatlar.
 *
 * ⛔ ISHLATILGAN KARTA CHOP ETILMAYDI va bu estetika emas: qog'ozga
 * tushgan `ACTIVATED` karta sotiladigan mahsulotdek ko'rinadi. Xaridor
 * pul to'laydi, kartani olib ketadi va kod ishlamasligini uydagi
 * telefonidan biladi — pulini esa allaqachon bergan. `EXPIRED` va
 * `VOIDED` ham xuddi shunday.
 *
 * ⚠️ To'plam {@link SECRET_STATES} BILAN BIR XIL bo'lib chiqdi va bu
 * tasodif emas: «hali ishlatilishi mumkinmi» degan savolga ikkalasi ham
 * javob beradi. Shunday bo'lsa ham ular AYRI e'lon qilingan — biri
 * XAVFSIZLIK, ikkinchisi MAHSULOT qarori va ular bir kun ajralishi
 * mumkin (masalan `SOLD` kartani qayta chop etish taqiqlansa).
 */
const PRINTABLE_STATES: ReadonlySet<VoucherState> = new Set<VoucherState>(['NEW', 'SOLD'])

/** Chop etishga tushadigan kartalar — qolganlari CHIQARIB TASHLANADI */
export function printableCards<T extends { state: VoucherState }>(
  cards: readonly T[],
): T[] {
  return cards.filter((card) => PRINTABLE_STATES.has(card.state))
}
